// Controls
import { LeftNavOption } from "./LeftNavOption";
// Styles
import { useLeftNavStaticSectionStyles } from "./LeftNavStaticSection.styles";
// Utilities
import { mergeClasses, useArrowNavigationGroup, useFocusableGroup } from "@fluentui/react-components";
import * as React from "react";
import { Strings } from "../../../utilities/CultureUtilities";
/**
 * LeftNav component for rendering static section
 */ export const LeftNavStaticSection = ({ staticOptions, isLeftNavCollapsed, keyCodeMapper })=>{
    const styles = useLeftNavStaticSectionStyles();
    // Enable keyboard navigation
    const focusableGroupAttributes = useFocusableGroup({
        tabBehavior: "limited"
    });
    const arrowNavigationAttributes = useArrowNavigationGroup({
        axis: "vertical",
        memorizeCurrent: false
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: mergeClasses(styles.root, isLeftNavCollapsed && styles.collapsed),
        ...focusableGroupAttributes,
        ...arrowNavigationAttributes
    }, /*#__PURE__*/ React.createElement("ul", {
        className: styles.optionsList,
        role: "listbox",
        "aria-label": Strings.LeftNav_StaticNavigationOptionsAriaLabel
    }, staticOptions.map((optionInfo, index)=>/*#__PURE__*/ React.createElement(LeftNavOption, {
            key: optionInfo.id,
            ...optionInfo,
            ariaPosInSet: index + 1,
            ariaSetSize: staticOptions.length,
            keyCodeMapper: keyCodeMapper
        }))));
};
